module.exports = __webpack_public_path__ + "static/media/dinner.477131f7.svg";